import styled from 'styled-components';
import { ChevronDown } from 'lucide-react';


export const Wrapper = styled.div`
  min-height: 85vh;
  background-color: #F9FAFB;
  display: flex;
  justify-content: start;
  align-items: start;
  font-family: sans-serif;
  padding: 20px;
`;

export const Card = styled.div`
  background-color: #ffffff;
  border-radius: 5px;
  width: 100%;
  max-width: 1200px;
  padding: 15px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LocationIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Divider = styled.hr`
  margin: 15px 0;
    border: 1px solid #e5e7eb;

`;

export const Brand = styled.span`
  font-weight: bold;
  font-size: 20px;
  color: #1F2937;
`;

export const CenterTitle = styled.h1`
  font-size: 20px;
  font-weight: bold;
  color: #1F2937;
  flex: 1;
  text-align: center;
`;

export const DropdownWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const Dropdown = styled.select`
  background-color: #f3f4f6;
  padding: 6px 32px 6px 12px;
  border-radius: 8px;
  font-size: 14px;
  color: #4B5563;
  border: none;
  appearance: none;
  cursor: pointer;
`;

// ChevronDown positioned absolutely on top of the select
export const ChevronIcon = styled(ChevronDown)`
  position: absolute;
  right: 10px;
  pointer-events: none;
  color: #6b7280;
`;


export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 20px;
`;

export const StatCard = styled.div`
  border: 1px solid #e5e7eb;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
`;

export const Label = styled.div`
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 8px;
`;

export const ValueRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Value = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #111827;
`;

export const Percent = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${props => (props.positive ? '#10b981' : '#ef4444')};
`;

export const Unit = styled.div`
  font-size: 14px;
  color: #6b7280;
`;

export const SmallValue = styled.div`
  font-size: 14px;
  color: #6b7280;
  margin-left: auto;
`;



export const ChartWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;
  flex-wrap: wrap;
`;


export const ChartCard = styled.div`
  flex: 1 1 300px;
  background: #fff;
  border: 1px solid #e5e7eb;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
`;


export const ChartTitle = styled.span`
  font-weight: bold;
  font-size: 16px;
  color: #1F2937;
`;
